import styled, { css } from 'styled-components';

export const ImagePlaceholder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%);
  color: #999;
  font-size: 13px;
  font-family: 'Poppins', sans-serif;
  height: 400px;
  width: 100%;
  border-radius: 8px;

  svg {
    font-size: 48px;
    margin-bottom: 8px;
    opacity: 0.5;
  }

  span {
    opacity: 0.7;
  }

  &.card {
    height: 200px;
    border-top-left-radius: 6px;
    border-top-right-radius: 0;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  &.card-room {
    height: 160px;
    border-radius: 8px;

    svg {
      font-size: 36px;
    }

    span {
      font-size: 11px;
    }
  }

  &.entertainment-card {
    height: 450px;
    width: 650px;
    border-radius: 10px;
  }
`;

export const Wrapper = styled.div`
  ${({ theme }) => css`
    position: relative;

    .carousel .carousel-status {
      position: absolute;
      top: auto;
      bottom: 8px;
      right: 8px;
      background: rgba(0, 0, 0, 0.6);
      color: #fff;
      font-size: 11px;
      font-weight: 500;
      padding: 4px 10px;
      border-radius: 12px;
      text-shadow: none;
      font-family: 'Poppins', sans-serif;
      backdrop-filter: blur(4px);
    }

    .carousel .control-dots {
      display: none;
    }

    .carousel .control-arrow {
      opacity: 0;
      transition: opacity 0.2s ease;
    }

    .carousel:hover .control-arrow {
      opacity: 1;
    }

    .carousel .control-prev.control-arrow:before,
    .carousel .control-next.control-arrow:before {
      border-width: 0 2px 2px 0;
      padding: 4px;
    }

    .image {
      height: 400px;
      object-fit: cover !important;

      &.card {
        height: 200px;
        width: 100%;
        object-fit: cover !important;
        border-top-left-radius: 6px;
      }

      &.card-room {
        width: 100%;
        height: 160px;
        object-fit: cover !important;
        border-radius: 8px;
      }

      &.entertainment-card {
        height: 450px;
        width: 650px;
        object-fit: cover !important;
        border-radius: 10px;
      }
    }
  `}
`;
